import { isDate } from "util";

var util = {
	errosLimpar(itemErros) {
		Object.entries(itemErros).forEach(([key]) => {
			itemErros[key] = { status: false, mensagem: "" };
		});
		return itemErros;
	},
	errosProcessar(itemErros, erros) {
		for (var indiceErro = 0; indiceErro < erros.length; indiceErro++) {
			var itemErro = erros[indiceErro];
			itemErros[itemErro.campo] = { status: true, mensagem: itemErro.mensagem };
		}

		return itemErros;
	},
	localStorageItem(key) {

		try{

			return JSON.parse(localStorage.getItem(key));

		}catch(err)
		{
			return null;
		}

	},
	calc_digitos_posicoes(digitos, posicoes = 10, soma_digitos = 0) {
		digitos = digitos.toString();
		for (var i = 0; i < digitos.length; i++) {
			soma_digitos = soma_digitos + digitos[i] * posicoes;
			posicoes--;
			if (posicoes < 2) {
				posicoes = 9;
			}
		}
		soma_digitos = soma_digitos % 11;
		if (soma_digitos < 2) {
			soma_digitos = 0;
		} else {
			soma_digitos = 11 - soma_digitos;
		}

		var cpf = digitos + soma_digitos;

		return cpf;
	},
	valida_cpf(valor) {
		valor = valor.toString();
		valor = valor.replace(/[^0-9]/g, "");
		var digitos = valor.substr(0, 9);
		var novo_cpf0 = this.calc_digitos_posicoes(digitos);
		var novo_cpf = this.calc_digitos_posicoes(novo_cpf0, 11);
		if (novo_cpf === valor && novo_cpf !== "11111111111" && novo_cpf !== "22222222222" && novo_cpf !== "33333333333" && novo_cpf !== "44444444444" && novo_cpf !== "55555555555" && novo_cpf !== "66666666666" && novo_cpf !== "77777777777" && novo_cpf !== "88888888888" && novo_cpf !== "99999999999") {
			return true;
		} else {
			return false;
		}
	},
	valida_cnpj(valor) {
		valor = valor.toString();
		valor = valor.replace(/[^0-9]/g, "");
		var cnpj_original = valor;
		var primeiros_numeros_cnpj = valor.substr(0, 12);
		var primeiro_calculo = this.calc_digitos_posicoes(primeiros_numeros_cnpj, 5);
		var segundo_calculo = this.calc_digitos_posicoes(primeiro_calculo, 6);
		var cnpj = segundo_calculo;
		if (cnpj === cnpj_original) {
			return true;
		}
		return false;
	},
	valida_email(email) {
		const emailRegexp = /^[a-zA-Z0-9][a-zA-Z0-9._-]+@([a-zA-Z0-9._-]+\.)[a-zA-Z-0-9]{2,3}$/;
		return emailRegexp.test(email);
	},
	valida_url(url) {
		const urlRegexp = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
		return urlRegexp.test(url);
	},
	valida_competencia_futura(compet) {
		var retorno = true;
		if (compet != null && compet != "") {
			var dataAtualAux = new Date();
			var dataAtual = new Date(dataAtualAux.getFullYear(), dataAtualAux.getMonth(), 1);
			var dataLimite = new Date(new Date(dataAtualAux.getFullYear() + 20, dataAtualAux.getMonth(), 1)); //limite para datas: 20 anos
			var x = compet.split("/");
			var confere = new Date(x[1], x[0] - 1, "01");
			var confere2 = (confere.getDate() < 10 ? "0" : "") + confere.getDate() + "/" + (confere.getMonth() + 1 < 10 ? "0" : "") + (confere.getMonth() + 1) + "/" + confere.getFullYear();
			compet = "01/" + compet;
			if (!confere || compet != confere2 || confere < dataAtual || confere > dataLimite) {
				retorno = false;
			}
		}
		return retorno;
	},

	limparObjeto(objeto, valor) {
		Object.keys(objeto).map((campo) => {
			objeto[campo] = valor;
		});
	},

	limpaSelecionados(lista) {
		lista.forEach((element) => {
			element.selecionado = 0;
		});
	},

	validaErros(objeto, erros) {
		//faz um map nas mensagens de retorno
		erros.map((erro) => {
			//faz um map no objeto de validação
			Object.keys(objeto).map((campo) => {
				//se encontrar o campo na mensagem ele seta a mensagem de erro
				if (erro.campo == campo) {
					if (Array.isArray(erro.mensagem)) {
						objeto[campo] = "";
						erro.mensagem.map((element) => {
							//se encontrar o campo na mensagem ele seta a mensagem de erro
							objeto[campo] += (objeto[campo] == "" ? "" : " | ") + element.mensagem;
						});
					}
					if (!objeto[campo]) {
						objeto[campo] = erro.mensagem;
					}
				}
			});
		});
	},

	isDDDvalido(ddd) {
		var retorno = ddd.match("((([1,4,6,8,9][1-9])|(2[1,2,4,7,8])|(3[1-5])|(3[7-8])|(5[1,3,4,5])|(7[1,3,4,5,7,9])))");
		return retorno != null;
	},

	valida_data(date) {
		var retorno = true;
		if (date != null && date != "") {
			date = date.substr(0, 10); //* remove a parte do horário
			var dataAtualAux = new Date();
			var dataLimiteInicio = new Date(new Date(2010, 0, 1));
			var dataLimiteFim = new Date(new Date(dataAtualAux.getFullYear() + 20, dataAtualAux.getMonth(), 1));

			var x = date.split("-");
			var confere = new Date(x[0], x[1] - 1, x[2]);
			var confere2 = confere.getFullYear() + "-" + (confere.getMonth() + 1 < 10 ? "0" : "") + (confere.getMonth() + 1) + "-" + (confere.getDate() < 10 ? "0" : "") + confere.getDate();
			if (!confere || date != confere2 || confere < dataLimiteInicio || confere > dataLimiteFim) {
				retorno = false;
			}
		} else {
			retorno = false;
		}
		return retorno;
	},

	valida_data_BR(date) {
		var retorno = true;
		if (date != null && date != "") {
			date = date.substr(0, 10); //* remove a parte do horário
			//limite para datas: 01/01/2010 a hoje+20 anos
			var dataAtualAux = new Date();
			var dataLimiteInicio = new Date(new Date(2010, 0, 1));
			var dataLimiteFim = new Date(new Date(dataAtualAux.getFullYear() + 20, dataAtualAux.getMonth(), 1));

			var x = date.split("/");
			var confere = new Date(x[2], x[1] - 1, x[0]);
			var confere2 = (confere.getDate() < 10 ? "0" : "") + confere.getDate() + "/" + (confere.getMonth() + 1 < 10 ? "0" : "") + (confere.getMonth() + 1) + "/" + confere.getFullYear();
			if (!confere || date != confere2 || confere < dataLimiteInicio || confere > dataLimiteFim) {
				retorno = false;
			}
		} else {
			retorno = false;
		}
		return retorno;
	},

	valida_data_nasc_BR(date) {
		var retorno = true;
		if (date != null && date != "") {
			date = date.substr(0, 10); //* remove a parte do horário
			var dataLimite = new Date(new Date(1900, 0, 1)); //limite para datas de nascimento: 01/01/1900

			var x = date.split("/");
			var confere = new Date(x[2], x[1] - 1, x[0]);
			var confere2 = (confere.getDate() < 10 ? "0" : "") + confere.getDate() + "/" + (confere.getMonth() + 1 < 10 ? "0" : "") + (confere.getMonth() + 1) + "/" + confere.getFullYear();
			if (!confere || date != confere2 || confere < dataLimite) {
				retorno = false;
			}
		} else {
			retorno = false;
		}
		return retorno;
	},

	valida_data_futura(date, hoje) {
		var retorno = true;
		if (date != null && date != "") {
			date = date.substr(0, 10); //* remove a parte do horário
			var dataAtual = new Date();
			if (hoje) {
				//* Considera o dia atual
				dataAtual.setDate(dataAtual.getDate() - 1);
			}
			var dataLimite = new Date(new Date(2010, 0, 1)); //limite para datas: 01/01/2010

			var x = date.split("-");
			var confere = new Date(x[0], x[1] - 1, x[2]);
			var confere2 = confere.getFullYear() + "-" + (confere.getMonth() + 1 < 10 ? "0" : "") + (confere.getMonth() + 1) + "-" + (confere.getDate() < 10 ? "0" : "") + confere.getDate();
			if (!confere || date != confere2 || confere < dataLimite || confere < dataAtual) {
				retorno = false;
			}
		}
		return retorno;
	},

	valida_data_futura_BR(date, hoje) {
		var retorno = true;
		if (date != null && date != "") {
			date = date.substr(0, 10); //* remove a parte do horário
			var dataAtual = new Date();
			if (hoje) {
				//* Considera o dia atual
				dataAtual.setDate(dataAtual.getDate() - 1);
			}
			var dataLimite = new Date(new Date(2010, 0, 1)); //limite para datas: 01/01/2010

			var x = date.split("/");
			var confere = new Date(x[2], x[1] - 1, x[0]);
			var confere2 = (confere.getDate() < 10 ? "0" : "") + confere.getDate() + "/" + (confere.getMonth() + 1 < 10 ? "0" : "") + (confere.getMonth() + 1) + "/" + confere.getFullYear();
			if (!confere || date != confere2 || confere < dataLimite || confere < dataAtual) {
				retorno = false;
			}
		}
		return retorno;
	},

	valida_data_passada_BR(date, hoje) {
		var retorno = true;
		if (date != null && date != "") {
			date = date.substr(0, 10); //* remove a parte do horário
			var dataAtual = new Date();
			if (!hoje) {
				//* Não considera o dia atual
				dataAtual.setDate(dataAtual.getDate() - 1);
			}
			var dataLimite = new Date(new Date(2010, 0, 1)); //limite para datas: 01/01/2010

			var x = date.split("/");
			var confere = new Date(x[2], x[1] - 1, x[0]);
			var confere2 = (confere.getDate() < 10 ? "0" : "") + confere.getDate() + "/" + (confere.getMonth() + 1 < 10 ? "0" : "") + (confere.getMonth() + 1) + "/" + confere.getFullYear();
			if (!confere || date != confere2 || confere < dataLimite || confere > dataAtual) {
				retorno = false;
			}
		}
		return retorno;
	},

	valida_hora(hora) {
		return !(hora.length != 5 || parseInt(hora.substring(0, 2)) > 23 || parseInt(hora.substring(3, 5)) > 59);
	},

	valida_nome(text) {
		if (text == "") {
			//* Não obriga o preenchimento, apenas verifica se não possui caracteres estranhos
			return true;
		}
		const textRegexp = /^[A-Za-záàâãéèêíïóôõöúüçñÁÀÂÃÉÈÍÏÓÔÕÖÚÜÇÑ'ºª&.\- \d]+$/;
		return textRegexp.test(text);
	},

	pLetra(text) {
		if (!text || text === "" || text.trim() === "") {
			return "";
		}

		//* Remove excesso de espaços em branco
		text = text.trim();
		do {
			text = text.replace("  ", " ");
		} while (text.indexOf("  ") > 0);

		if (text !== text.toLowerCase() && text !== text.toUpperCase()) {
			//* Só irá converter se todos os caracteres estiverem em minúsculos ou maiúsculos (para permitir manter uma correção, ex: APM - Associação de Pais e Mestres)
			return text;
		}
		// if (
		//   text.length < 5 &&
		//   text.split(" ").length == 1 &&
		//   text === text.toUpperCase()
		// ) {
		//   //NÃO, FICA Opec mesmo ou usam outro nome, ex Operacional - Se nome é apenas uma única palavra maiúscula (ex: OPEC), mantém em maiúscula
		//   return text;
		// }
		if (text === text.toUpperCase()) {
			//* Para padronização do sistema, não permite nomes totalmente em maiúsculas
			text = text.toLowerCase();
		}
		var words = text.split(" ");
		for (var a = 0; a < words.length; a++) {
			//* Converte primeira letra de cada palavra em maiúsculo, ignorando os artigos e conjunções abaixo
			var w = words[a];
			words[a] = w[0].toUpperCase() + w.slice(1).toLowerCase();
			if (w === "da" || w === "de" || w === "do" || w === "das" || w === "dos" || w === "a" || w === "e" || w === "o" || w === "com" || w === "na" || w === "em" || w === "no") {
				words[a] = w;
			}
			if (w === w.toUpperCase()) {
				//* Mantém siglas em maiúsculas
				words[a] = w;
			}
		}
		return words.join(" ");
	},
	formatDate(date) {
		if (isDate(date)) {
			date = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
		}
		if (!date) return null;
		if (date.indexOf("T")) {
			date = date.split("T")[0];
		}
		if (date.indexOf(" ")) {
			date = date.split(" ")[0];
		}
		const [year, month, day] = date.split("-");
		return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
	},
	formatDateUS(date) {
		if (!date) return null;
		const [day, month, year] = date.split("/");
		return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
	},
	parseDate(date) {
		if (!date) return null;
		const [day, month, year] = date.split("/");
		return new Date(year, month - 1, day);
	},
	parseDateUS(date) {
		if (!date) return null;
		if (isDate(date)) {
			date = date.getFullYear() + "-" + (date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1) + "-" + (date.getDate() < 10 ? "0" : "") + date.getDate();
		}
		date = date.substr(0, 10); //* remove a parte do horário
		const [year, month, day] = date.split("-");
		return new Date(year, month - 1, day, 0, 0, 0, 0);
	},

	formatDateTime(datetime) {
		if (!datetime) return null;
		if (datetime && datetime != null && datetime != "") {
			var options = {
				year: "numeric",
				month: "numeric",
				day: "numeric",
				hour: "2-digit",
				minute: "2-digit",
				second: "2-digit"
				//timeZoneName: "short",
				//timeZone: "UTC"
			};
			datetime = new Date(datetime);
			var portugueseTime = new Intl.DateTimeFormat(["pt-BR", "pt-PT"], options);
			return portugueseTime.format(datetime);
		} else {
			return null;
		}
	},
	formatDateTimeSimple(datetime) {
		if (!datetime) return null;
		if (datetime && datetime != null && datetime != "") {
			var options = {
				year: "numeric",
				month: "numeric",
				day: "numeric",
				hour: "2-digit",
				minute: "2-digit"
				//second: "2-digit"
				//timeZoneName: "short",
				//timeZone: "UTC"
			};
			datetime = new Date(datetime);
			var portugueseTime = new Intl.DateTimeFormat(["pt-BR", "pt-PT"], options);
			return portugueseTime.format(datetime);
		} else {
			return null;
		}
	},
	formatDateUSTime(datetime) {
		if (!datetime) return null;
		var date = datetime.split(" ")[0];
		var time = datetime.split(" ")[1];
		const [day, month, year] = date.split("/");
		var [hour, minute, second] = time.split(":");
		return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")} ${hour}:${minute}:${second}`;
	},
	dateToStringUS(date) {
		if (isDate(date)) {
			date = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
		}
		if (!date) return null;
		if (date.indexOf("T")) {
			date = date.split("T")[0];
		}
		if (date.indexOf(" ")) {
			date = date.split(" ")[0];
		}
		const [year, month, day] = date.split("-");
		return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
	},
	dateDiffDays(date1, date2) {
		var dt1 = new Date(date1);
		var dt2 = new Date(date2);
		return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
	},
	formatCurrency(valor) {
		if (!valor) return "0,00";

		const formatter = new Intl.NumberFormat("pt-BR", {
			style: "decimal",
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
		return formatter.format(valor);
	},
	formatCurrencyNoLimit(valor) {
		if (!valor) return "0,00";

		const formatter = new Intl.NumberFormat("pt-BR", {
			style: "decimal",
			minimumFractionDigits: 2,
			maximumFractionDigits: 20
		});
		return formatter.format(valor);
	},
	formatDouble(valor) {
		if (!valor) return "0";
		const formatter = new Intl.NumberFormat("pt-BR", {
			style: "decimal",
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		});
		return formatter.format(valor);
	},
	formatCurrency4(valor) {
		if (!valor) return "0,0000";
		const formatter = new Intl.NumberFormat("pt-BR", {
			style: "decimal",
			minimumFractionDigits: 4
		});
		return formatter.format(valor);
	},
	escondeCartao(numero) {
		var retorno = "";
		if (numero != null && numero != "" && numero.length > 11) {
			retorno = "***" + numero.substring(12);
		}
		return retorno;
	},
	isFormaPgto1Parcela(tipoFormaPgto) {
		var retorno = false;
		var formasPgto = ["A_VISTA", "BONIFICACAO", "COMPENSACAO", "CORTESIA", "CREDITO", "PACOTE", "PERMUTA_PAGAR", "PERMUTA_RECEBER"];
		if (formasPgto.includes(tipoFormaPgto)) {
			retorno = true;
		}
		return retorno;
	},
	isFormaPgtoValorZero(tipoFormaPgto) {
		var retorno = false;
		var formasPgto = ["BONIFICACAO", "COMPENSACAO", "CORTESIA"];
		if (formasPgto.includes(tipoFormaPgto)) {
			retorno = true;
		}
		return retorno;
	},
	imprimir(corpo) {
		const WinPrint = window.open("", "", "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0");

		WinPrint.document.write(corpo);
		WinPrint.document.close();
		WinPrint.onload = function() {
			//* Dá uma pausa para esperar carregar a imagem e a fonte (se houver)
			WinPrint.focus();
			//WinPrint.print();
			//WinPrint.close();
		};
	},
	nullToString(valor) {
		return valor == null || valor == "undefined" ? "" : valor.toString();
	},
	removeAcentos(texto) {
		if (texto) {
			texto = texto.replace("  ", " ");
			texto = texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
			texto = texto.trim();
		}
		return texto;
	},
	somenteNumeros(valor) {
		return valor.replace(/[^0-9]/g, "");
	},
	filtrarObjetos(item, queryText, itemText) {
		if (queryText === null || queryText.length === 0) {
			return true;
		}
		var text = util.removeAcentos(item["nome"]).toLowerCase();
		queryText = util.removeAcentos(queryText).toLowerCase();
		return itemText && itemText.length > 0 && text.indexOf(queryText) > -1;
	},
	filtrarItens(item, queryText, itemText) {
		if (queryText === null || queryText.length === 0) {
			return true;
		}
		var text = util.removeAcentos(item).toLowerCase();
		queryText = util.removeAcentos(queryText).toLowerCase();
		return itemText && itemText.length > 0 && text.indexOf(queryText) > -1;
	},
	filtrarUFs(item, queryText, itemText) {
		if (queryText === null || queryText.length === 0) {
			return true;
		}
		var text = (queryText.length > 2 ? util.removeAcentos(item["nome"]).toLowerCase() : "") + "-" + item["sigla"].toLowerCase();
		queryText = util.removeAcentos(queryText).toLowerCase();
		return itemText && itemText.length > 0 && text.indexOf(queryText) > -1;
	},
	guidGenerator() {
		var S4 = function() {
			return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
		};
		return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
	},
	emailMaskHide(email) {
		var maskedEmail = email.replace(/([^@.])/g, "*").split("");
		var previous = "";
		for (var i = 0; i < maskedEmail.length; i++) {
			if (i <= 1 || previous == "." || previous == "@") {
				maskedEmail[i] = email[i];
			}
			previous = email[i];
		}
		return maskedEmail.join("");
	},
	modosEntrega() {
		return ["Area / Var", "Basculante", "Bxo Pta", "Bxo Pta Ed", "Bxo Tapete", "Cano Pvc", "Cx Coletor", "Cx Correio", "Gar Esq", "Garagem", "Gr Direita", "Grade", "Janela", "Patio", "Porta", "Portao", "Portaria", "Pta Fundos", "Pta Servic", "Pto Retira", "Sac Direit", "Sac Meio", "Sacada", "Sacada Esq", "Seguranca"];
	},
	tiposLogradouros() {
		return [
			"Aeroporto",
			"Alameda",
			"Área",
			"Avenida",
			"Campo",
			"Chácara",
			"Colônia",
			"Condomínio",
			"Conjunto",
			"Distrito",
			"Esplanada",
			"Estação",
			"Estrada",
			"Favela",
			"Fazenda",
			"Feira",
			"Jardim",
			"Ladeira",
			"Lago",
			"Lagoa",
			"Largo",
			"Linha",
			"Loteamento",
			"Morro",
			"Núcleo",
			"Parque",
			"Passarela",
			"Pátio",
			"Praça",
			"Quadra",
			"Recanto",
			"Residencial",
			"Rodovia",
			"Rua",
			"Servidão",
			"Setor",
			"Sítio",
			"Travessa",
			"Trecho",
			"Trevo",
			"Vale",
			"Vereda",
			"Via",
			"Viaduto",
			"Viela",
			"Vila"
		];
	},
	countryNameToCode(countryName) {
		let countryToCode = {
			Afghanistan: "AF",
			Albania: "AL",
			Algeria: "DZ",
			Andorra: "AD",
			Angola: "AO",
			Argentina: "AR",
			Armenia: "AM",
			Australia: "AU",
			Austria: "AT",
			Azerbaijan: "AZ",
			Bahamas: "BS",
			Bahrain: "BH",
			Bangladesh: "BD",
			Barbados: "BB",
			Belarus: "BY",
			Belgium: "BE",
			Belize: "BZ",
			Benin: "BJ",
			Bhutan: "BT",
			Bolivia: "BO",
			"Bosnia and Herzegovina": "BA",
			Botswana: "BW",
			Brazil: "BR",
			Brunei: "BN",
			Bulgaria: "BG",
			"Burkina Faso": "BF",
			Burundi: "BI",
			"Cabo Verde": "CV",
			Cambodia: "KH",
			Cameroon: "CM",
			Canada: "CA",
			"Central African Republic": "CF",
			Chad: "TD",
			Chile: "CL",
			China: "CN",
			Colombia: "CO",
			Comoros: "KM",
			Congo: "CG",
			"Costa Rica": "CR",
			Croatia: "HR",
			Cuba: "CU",
			Cyprus: "CY",
			"Czech Republic": "CZ",
			Denmark: "DK",
			Djibouti: "DJ",
			Dominica: "DM",
			"Dominican Republic": "DO",
			Ecuador: "EC",
			Egypt: "EG",
			"El Salvador": "SV",
			"Equatorial Guinea": "GQ",
			Eritrea: "ER",
			Estonia: "EE",
			Eswatini: "SZ",
			Ethiopia: "ET",
			England: "GB-ENG",
			Fiji: "FJ",
			Finland: "FI",
			France: "FR",
			Gabon: "GA",
			Gambia: "GM",
			Georgia: "GE",
			Germany: "DE",
			Ghana: "GH",
			Greece: "GR",
			Grenada: "GD",
			Guatemala: "GT",
			Guinea: "GN",
			"Guinea-Bissau": "GW",
			Guyana: "GY",
			Haiti: "HT",
			Honduras: "HN",
			Hungary: "HU",
			Iceland: "IS",
			India: "IN",
			Indonesia: "ID",
			Iran: "IR",
			Iraq: "IQ",
			Ireland: "IE",
			Israel: "IL",
			Italy: "IT",
			Jamaica: "JM",
			Japan: "JP",
			Jordan: "JO",
			Kazakhstan: "KZ",
			Kenya: "KE",
			Kiribati: "KI",
			Kuwait: "KW",
			Kyrgyzstan: "KG",
			Laos: "LA",
			Latvia: "LV",
			Lebanon: "LB",
			Lesotho: "LS",
			Liberia: "LR",
			Libya: "LY",
			Liechtenstein: "LI",
			Lithuania: "LT",
			Luxembourg: "LU",
			Madagascar: "MG",
			Malawi: "MW",
			Malaysia: "MY",
			Maldives: "MV",
			Mali: "ML",
			Malta: "MT",
			"Marshall Islands": "MH",
			Mauritania: "MR",
			Mauritius: "MU",
			Mexico: "MX",
			Micronesia: "FM",
			Moldova: "MD",
			Monaco: "MC",
			Mongolia: "MN",
			Montenegro: "ME",
			Morocco: "MA",
			Mozambique: "MZ",
			Myanmar: "MM",
			Namibia: "NA",
			Nauru: "NR",
			Nepal: "NP",
			Netherlands: "NL",
			"New Zealand": "NZ",
			Nicaragua: "NI",
			Niger: "NE",
			Nigeria: "NG",
			"North Korea": "KP",
			"North Macedonia": "MK",
			Norway: "NO",
			Oman: "OM",
			Pakistan: "PK",
			Palau: "PW",
			Palestine: "PS",
			Panama: "PA",
			"Papua New Guinea": "PG",
			Paraguay: "PY",
			Peru: "PE",
			Philippines: "PH",
			Poland: "PL",
			Portugal: "PT",
			Qatar: "QA",
			Romania: "RO",
			Russia: "RU",
			Rwanda: "RW",
			"Saint Kitts and Nevis": "KN",
			"Saint Lucia": "LC",
			"Saint Vincent and the Grenadines": "VC",
			Samoa: "WS",
			"San Marino": "SM",
			"Sao Tome and Principe": "ST",
			"Saudi Arabia": "SA",
			Senegal: "SN",
			Serbia: "RS",
			Seychelles: "SC",
			"Sierra Leone": "SL",
			Singapore: "SG",
			Slovakia: "SK",
			Slovenia: "SI",
			"Solomon Islands": "SB",
			Somalia: "SO",
			"South Africa": "ZA",
			"South Korea": "KR",
			"South Sudan": "SS",
			Spain: "ES",
			"Sri Lanka": "LK",
			Sudan: "SD",
			Suriname: "SR",
			Sweden: "SE",
			Switzerland: "CH",
			Syria: "SY",
			Scotland: "GB-SCT",
			Taiwan: "TW",
			Tajikistan: "TJ",
			Tanzania: "TZ",
			Thailand: "TH",
			"Timor-Leste": "TL",
			Togo: "TG",
			Tonga: "TO",
			"Trinidad and Tobago": "TT",
			Tunisia: "TN",
			Turkey: "TR",
			Turkmenistan: "TM",
			Tuvalu: "TV",
			Uganda: "UG",
			Ukraine: "UA",
			"United Arab Emirates": "AE",
			"United Kingdom": "GB",
			"United States": "US",
			Uruguay: "UY",
			Uzbekistan: "UZ",
			USA: "US",
			Vanuatu: "VU",
			"Vatican City": "VA",
			Venezuela: "VE",
			Vietnam: "VN",
			Yemen: "YE",
			Zambia: "ZM",
			Zimbabwe: "ZW"
		};

		const code = countryToCode[countryName];
		if (code) {
			return code;
		} else {
			return ""; // ou você pode lançar um erro ou retornar null
		}
	},
	convertArrayToObject(array, key) {
		const initialValue = {};
		return array.reduce((obj, item) => {
			return {
				...obj,
				[item[key]]: item
			};
		}, initialValue);
	}
};

export default util;
